import { isCurrencyUsd, getCurrencyLabel } from '../../helpers/currency';

export const roundNumber = (value, step) => {
  const remainder = value % step;

  return remainder < step / 2 ? value - remainder : value + (step - remainder);
};

const getUsdDefaultFullRange = (defaultRange) => {
  const range = [];

  defaultRange.forEach((item, index) => {
    const step = roundNumber(Math.round(defaultRange[index].step / window.currencyRateUSD), 500);
    range[index] = {
      value: roundNumber(Math.round(defaultRange[index].value / window.currencyRateUSD), step),
      step,
    };
  });

  return range;
};

export const ONE_MILLION = 1000000;
export const ONE_THOUSAND = 1000;
export const MIN_FULL_RANGE_STEP = 50 * ONE_THOUSAND;
export const MIN_SQM_RANGE_STEP = ONE_THOUSAND;
export const DEFAULT_FULL_RANGE = [
  {
    value: 4 * ONE_MILLION,
    step: 500 * ONE_THOUSAND,
  },
  {
    value: 2 * ONE_MILLION,
    step: 200 * ONE_THOUSAND,
  },
  {
    value: ONE_MILLION,
    step: 100 * ONE_THOUSAND,
  },
];

export const USD_MIN_FULL_RANGE_STEP = roundNumber(
  Math.round(MIN_FULL_RANGE_STEP / window.currencyRateUSD),
  100,
);
export const USD_MIN_SQM_RANGE_STEP = Math.round(MIN_SQM_RANGE_STEP / window.currencyRateUSD);
export const USD_DEFAULT_FULL_RANGE = getUsdDefaultFullRange(DEFAULT_FULL_RANGE);

export const formatNumberTo = (value) => {
  const newValue = Math.round(value);
  if (newValue >= ONE_MILLION) {
    return `${(newValue / ONE_MILLION).toFixed(2)} млн`;
  }
  if (newValue >= ONE_THOUSAND) {
    return `${String(newValue).slice(0, -3)} ${String(newValue).slice(-3)}`;
  }
  return String(newValue);
};

export const formatNumberFrom = (value, min, max) => {
  let newValue = value;
  if (value.indexOf('млн') !== -1) {
    const number = value.split(' ')[0];
    newValue = number * ONE_MILLION;
  } else if (value.indexOf(' ') !== -1) {
    newValue = value.split(' ').join('');
  }
  if (newValue === min) return min;
  if (newValue === max) return max;
  return Math.round(newValue);
};

export const scaleToPrice = (values, min, max) => {
  return values.map((value) => formatNumberFrom(value, min, max));
};

export const getValuesLabel = (values, defaultMin, defaultMax, currency, showMoreSymbol = false) => {
  const [minPrice, maxPrice] = scaleToPrice(values, defaultMin, defaultMax);
  const minPriceLabel = formatNumberTo(minPrice);
  const maxPriceLabel = formatNumberTo(maxPrice);
  const currencySymbol = getCurrencyLabel(currency);
  const moreSymbol = showMoreSymbol && maxPrice === defaultMax ? ' +' : '';

  return isCurrencyUsd(currency) ? {
    min: `${currencySymbol} ${minPriceLabel}`,
    max: `${currencySymbol} ${maxPriceLabel}${moreSymbol}`,
  } : {
    min: `${minPriceLabel} ${currencySymbol}`,
    max: `${maxPriceLabel} ${currencySymbol}${moreSymbol}`,
  };
};

export const roundNumberForFullRange = (value, range, step) => {
  const rangeItem = range.find((item) => value > item.value);

  return roundNumber(value, rangeItem ? rangeItem.step : step);
};

export const getNumber = (value, isUsd, isFullRange) => {
  if (isFullRange) {
    const range = isUsd ? USD_DEFAULT_FULL_RANGE : DEFAULT_FULL_RANGE;
    const step = isUsd ? USD_MIN_FULL_RANGE_STEP : MIN_FULL_RANGE_STEP;
    return roundNumberForFullRange(value, range, step);
  }

  return roundNumber(value, isUsd ? USD_MIN_SQM_RANGE_STEP : MIN_SQM_RANGE_STEP);
};

export const fullRange = (min, max, range, step) => {
  const filteredRange = range.filter((item) => max > item.value && item.value > min).reverse();
  const rangeStep = Math.floor(100 / (filteredRange.length + 1));
  const firstStep = (filteredRange[0]?.value - min) % step;
  const newRange = { min: [min, firstStep || step] };

  if (firstStep) {
    const firstStepPercents =
      Math.round((firstStep * rangeStep) / (filteredRange[0].value - min)) || 1;
    newRange[`${firstStepPercents}%`] = [min + firstStep, step];
  }

  filteredRange.forEach((item, index) => {
    newRange[`${rangeStep * (index + 1)}%`] = [item.value, item.step];
  });
  newRange.max = [max];

  return newRange;
};

export const sqmRange = (min, max, step) => {
  return {
    min: [roundNumber(min, step), step],
    max: [roundNumber(max, step)],
  };
};
